import React, {useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { EditOutlined } from '@mui/icons-material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

import { getCancelationConstantsRequest } from '../../../store/Settings/actions'
import messages from "../../../assets/locale/messages";
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import { setPageMainTitle } from '../../../utils/Helpers';
import { isSuperAdmin } from '../../../utils/Permissions';
import Switch from '../../../components/Switch';
import Button from '../../../components/Button';

const CancellationPolicy = () => {

    const dispatch = useDispatch()
    const lang = useSelector((state) => state.locale.lang);
    const cancellationPolicyConstants = useSelector((state) => state.settings.cancellationPolicyConstants);
    const { settings, shared } = messages[lang];
    const history = useHistory();

    useEffect(() => {
        setPageMainTitle('SettingsManagment');
        dispatch(getCancelationConstantsRequest());
    }, []);

    return(
        <>
            <div className="d-flex justify-content-between mb-4">
                <span className="fsize-30 fweight-600 d-flex gap-1 text-primary">
                    <span
                        className="pointer"
                        onClick={()=>{
                            history.push(ROUTE_PATHS.settings)
                        }}
                    >
                        { lang === 'en' ? 
                            (<ArrowBackIosOutlinedIcon/>) : 
                            (<ArrowForwardIosOutlinedIcon/>)
                          }
                    </span>
                    <span  className="mt-1">{settings.viewSettings.cancellationPolicy}</span>
                </span> 
                {isSuperAdmin() && (
                    <Button
                    label={<span className="d-flex gap-1 px-2">
                                <span><EditOutlined fontSize="small" /></span>
                                <span>{shared.edit}</span>
                            </span>}
                    labelClass="fsize-16 text-white py-1"
                    onClick={() => {history.push(ROUTE_PATHS.editCancellationPolicy)}}
                />
                )}
            </div>
            
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="text-secondary mb-2">
                    {settings.cancellationPolicy.cancellationDuration}:
                </div>
                <div className="mb-1 fsize-16">
                    {settings.cancellationPolicy.cancelationDurationlabel}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {cancellationPolicyConstants.cancellationCutoffHours} {settings.cancellationPolicy.hours}
                </div>
            </div>
            <div className="bg-white rounded-4 px-5 py-4 fsize-18 fweight-400">
                <div className="text-secondary mb-2">
                    {settings.cancellationPolicy.consecutiveCancellations}:
                </div>
                <div className="d-flex gap-3 mb-2">
                    <div className="mb-1 text-gray">
                        {settings.cancellationPolicy.consecutiveCancellationsText}
                    </div>
                    <Switch
                        disabled
                        checked={cancellationPolicyConstants.allowConsecutiveCancellations}
                    />
                </div>
                {!cancellationPolicyConstants.allowConsecutiveCancellations && (
                    <div>
                        <div className="fsize-16 fweight-400 mb-2 ">
                            {settings.cancellationPolicy.maxNumberOfConsecutiveCancellations}*
                            <div className=" fweight-500 text-gray">
                                {cancellationPolicyConstants.maxConsecutiveCancellations}
                            </div>
                        </div>
                        <div className="fsize-16 fweight-400">
                            {settings.cancellationPolicy.numberOfDaysForPreventingFurtherCancelllations}*
                            <div className="fweight-500 text-gray">
                                {cancellationPolicyConstants.cancellationPreventionDays} {settings.cancellationPolicy.days}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default CancellationPolicy;